<template>
  <div class="row p-2">
    <div class="col-md-8">
      <div class="style--dark pt-3 px-3">
        <h3>
          Detrás de cada reseña, hay un sueño cumplido y un hogar hecho realidad
        </h3>
        <div class="google-stars pt-2 pb-1">
          <img src="/img/icons/google-icon.svg" />
          <ul>
            <li
              class="star"
              v-for="n in Math.floor(averageReviews)"
              :key="'full-' + n"
            >
              <div class="range" style="width: 100%"></div>
            </li>

            <li class="star" v-if="hasHalfStar(averageReviews)">
              <div
                class="range"
                :style="{ width: getHalfStarWidth(averageReviews) + '%' }"
              ></div>
            </li>

            <li
              class="star empty"
              v-for="n in getEmptyStars(averageReviews)"
              :key="'empty-' + n"
            >
              <div class="range" style="width: 0%"></div>
            </li>
          </ul>

          <p class="txt"><b>{{ averageReviews }}</b> estrellas | <b>{{ totalReviews }}</b> reseñas</p>
        </div>
        <p class="google-stars_mobile"><b>{{ averageReviews }}</b> estrellas | <b>{{ totalReviews }}</b> reseñas</p>
        <p>
          <a v-if="reviews[0].LINK_____REVIEW" :href="reviews[0].LINK_____REVIEW" class="btn btn-dark pt-1" target="_blank">Ver más reseñas</a>
        </p>
      </div>
    </div>
    <div class="col-md-4"></div>

    <div class="col-md-12 py-3">
      <section id="renenas__slide" class="splide" ref="reviews">
        <div class="splide__track">
          <ul class="splide__list">
            <li
              class="splide__slide"
              v-for="(review, index) in reviews"
              :key="index"
            >
              <div class="single__quote">
                <div class="user__quote">
                  <img
                    class="img-circle"
                    src="/img/homepage/google-ren-user_icon.svg"
                  />
                  {{ review.NOMINATIVO__REV }}
                </div>
                <div class="google-stars pb-1">
                  <ul>
                    <li
                      class="star"
                      v-for="n in review.VOTO_____REVIEW"
                      :key="'full-' + n"
                    >
                      <div class="range" style="width: 100%"></div>
                    </li>

                    <li
                      class="star empty"
                      v-for="n in getEmptyStars(review.VOTO_____REVIEW)"
                      :key="'empty-' + n"
                    >
                      <div class="range" style="width: 0%"></div>
                    </li>
                  </ul>
                </div>
                <div class="text__quote">
                  <p v-html="review.TESTO____REVIEW"></p>
                  <p class="g__date smallTxt">
                    {{ formatDate(review.DATA_____REVIEW) }}
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Splide from "@splidejs/splide";

export default {
  props: {
    reviews: Array,
    averageReviews: Number,
    totalReviews: Number,
  },

  mounted() {
    new Splide(this.$refs.reviews, {
      perPage: 3,
      arrows: false,
      perMove: 1,
      autoHeight: true,
      gap: "2em",
      pagination: true,
      breakpoints: {
        1024: {
          perPage: 3,
        },
        767: {
          perPage: 2,
        },
        640: {
          perPage: 1,
        },
      },
    }).mount();
  },

  methods: {
    formatDate(dateString) {
      if (!dateString) return "";

      const date = new Date(dateString);
      return new Intl.DateTimeFormat("it-IT", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }).format(date);
    },

    getFullStars(rate) {
      return Math.floor(rate);
    },

    hasHalfStar(rate) {
      return rate % 1 !== 0;
    },

    getHalfStarWidth(rate) {
      return (rate % 1) * 100;
    },

    getEmptyStars(rate) {
      return 5 - Math.ceil(rate);
    }
  },
};
</script>

<style>
@import "@splidejs/splide/dist/css/splide.min.css";
</style>
